define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/StorageUtil',
	'model/ActivationType',
	'state/UIState',
	'service/UIStateManager',
	'service/EventListenerRegistry',
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/ControlView',
	'view/ControlBarView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/AuthenticationOptionSelectionState_strings'
], function (
	Logger,
	Util,
	StorageUtil,
	ActivationType,
	UIState,
	UIStateManager,
	EventListenerRegistry,
	ProviderInfoView,
	NavigationView,
	ControlView,
	ControlBarView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * AuthenticationOptionSelectionState class
	 */
	function AuthenticationOptionSelectionState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_controlView = new ControlView(authenticationOptionClickHandler),
			_controlBarView = new ControlBarView('skIdS_control-bar-authentication-option-selection'),
			_cloudIdentitiesManagementButton,
			_authenticationOptions = null,
			_authenticationOptionEidClient = null;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.choose_identity);

		_cloudIdentitiesManagementButton = _controlBarView.addButton(Strings.identity_management, function () {
			_uiStateManager.changeContext();
		}, 0);

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.abort();
		});

		UIState.call(this, 'authentication_option_selection');


		// private methods

		function authenticationOptionClickHandler(authenticationOption) {
			var identities;

			var reqAttr = _uiStateManager.core().optionsManager().requestedAttributes();
				reqAttr.concat(authenticationOption.requestedAttributes());

			if (authenticationOption.cloudID()) {
				identities = _uiStateManager.core().cloudIdentitiesManager()
                                        .getIdentitiesByAuthenticationOption(authenticationOption, 
                                                                            _uiStateManager.core().optionsManager());
				
				if (identities.length  === 0) {
					StorageUtil.store('authentication_option', authenticationOption.toObject(), true);
					StorageUtil.store('requested_attributes',
							Util.serialize(_uiStateManager.core().optionsManager().requestedAttributes()), true);

					_uiStateManager.changeContext();
				} else if (!identities[0].isValid()) {
					//Trigger renew of CloudID (#1411)
					StorageUtil.store('renew_cid', authenticationOption.toObject(), true);
					_uiStateManager.changeContext();
				} else {
					// TODO: extend for multi-cloudid case
					_uiStateManager.change('attributes_selection', {
						authenticationOption : authenticationOption,
						requestedAttributes : reqAttr,
						identity : identities[0]
					});
				}
			} else {
			    var filteredReqAttr = [];
			    var reqAttrTest = authenticationOption.requestedAttributes();
			    for (var attr in reqAttrTest) {
				if (reqAttrTest[attr].isRequired()) {
				    filteredReqAttr.push(reqAttrTest[attr]);
				}
			    }
			    //console.info(filteredReqAttr);
			    if (filteredReqAttr.length === reqAttrTest.length && 
				    filteredReqAttr.length === 1 &&
				    filteredReqAttr[0].name() === "http://www.skidentity.de/att/eIdentifier") {
				//skip attr-selection if only eIdentifier is req
				_uiStateManager.change('activation', {
				    authenticationOption : authenticationOption,
				    requestedAttributes : filteredReqAttr
				});
			    } else {
				_uiStateManager.change('attributes_selection', {
				    authenticationOption : authenticationOption,
				    requestedAttributes : reqAttr
				});
			    }
			}
		}

                //TODO: add to util
		function filterAuthenticationOptions(authenticationOptions) {
			var eidClients = _uiStateManager.core().eidClientManager().supportedEidClients(),
				filteredAuthenticationOptions = new Array(),
				i, j;

			for (i = 0; i < authenticationOptions.length; i++) {
				if (authenticationOptions[i].cloudID() || authenticationOptions[i].activation() === ActivationType.BROWSER) {
					filteredAuthenticationOptions.push(authenticationOptions[i]);
				} else {
					for (j = 0; j < eidClients.length; j++) {
						if (eidClients[j].supportsAuthenticationOption(authenticationOptions[i])) {
							filteredAuthenticationOptions.push(authenticationOptions[i]);
							break;
						}
					}
				}
			}

			return filteredAuthenticationOptions;
		}

		function initAuthenticationOptionViews() {
			var cloudIdentitiesManager = _uiStateManager.core().cloudIdentitiesManager(),
				authenticationOption,
				identities,
				i;

			for (i = 0; i < _authenticationOptions.length; i++) {
				authenticationOption = _authenticationOptions[i];

				if (!authenticationOption.cloudID()) {
					continue;
				}

				identities = _uiStateManager.core().cloudIdentitiesManager()
                                        .getIdentitiesByAuthenticationOption(authenticationOption, 
                                                                            _uiStateManager.core().optionsManager());

				if (identities.length === 0) {
					_controlView.enableAuthenticationOptionToolTip(authenticationOption, Strings.create_cloud_identity);
				} else if (identities.length === 1 && !identities[0].isUsable()) {
					_controlView.disableAuthenticationOption(authenticationOption, false);
					if(!identities[0].isEnabled()) { //Only deactivat callback if cloudID is deactivated
						_controlView.disableAuthenticationOptionCallback(authenticationOption);
					}
					_controlView.enableAuthenticationOptionToolTip(authenticationOption,
							(!identities[0].isValid() ? Strings.cloud_identity_expired : Strings.cloud_identity_deactivated)
					);
				} else {
					// TODO: implement display if multiple matching cloudids are available
				}
			}
		}

		function eidClientDetectionCycleFinished(eidClients) {
			var authenticationOption,
				handled,
				i, j;

			for (i = 0; i < _authenticationOptions.length; i++) {
				authenticationOption = _authenticationOptions[i];

				if (authenticationOption.activation() !== ActivationType.EID_CLIENT) {
					continue;
				}

				handled = false;

				for (j = 0; j < eidClients.length; j++) {
					if (eidClients[j].supportsAuthenticationOption(authenticationOption)) {
						_controlView.enableAuthenticationOptionCallback(authenticationOption);

						if (!_authenticationOptionEidClient.hasOwnProperty(authenticationOption.id())) {
							if (eidClients[j].supportsStatus()) {
								_controlView.disableAuthenticationOption(authenticationOption);

								_controlView.enableAuthenticationOptionToolTip(authenticationOption,
										authenticationOption.description() + ' ' + Strings.not_available);
							} else {
								_controlView.enableAuthenticationOptionToolTip(authenticationOption,
										authenticationOption.description());
							}
						}

						_authenticationOptionEidClient[authenticationOption.id()] = eidClients[j].id()

						handled = true;
						break;
					}
				}

				if (!handled && _authenticationOptionEidClient.hasOwnProperty(authenticationOption.id())) {
					if (eidClients.length !== 0) {
						_authenticationOptionEidClient[authenticationOption.id()] = null;

						_controlView.disableAuthenticationOption(authenticationOption);
						_controlView.disableAuthenticationOptionCallback(authenticationOption);

						_controlView.enableAuthenticationOptionToolTip(authenticationOption,
								authenticationOption.description() + ' ' + Strings.not_supported);
					} else {
						delete _authenticationOptionEidClient[authenticationOption.id()];

						_controlView.enableAuthenticationOption(authenticationOption);
						_controlView.enableAuthenticationOptionCallback(authenticationOption);

						_controlView.enableAuthenticationOptionToolTip(authenticationOption, authenticationOption.description());
					}
				}
			}
		}

		function cardRecognized(data) {
			for (var i = 0; i < _authenticationOptions.length; i++) {
				if (_authenticationOptions[i].activation() !== ActivationType.EID_CLIENT
						|| !_authenticationOptions[i].matchesType(data.card.type())) {
					continue;
				}

				_controlView.enableAuthenticationOption(_authenticationOptions[i]);

				_controlView.enableAuthenticationOptionToolTip(_authenticationOptions[i], _authenticationOptions[i].description());
			}
		}

		function cardRemoved(data) {
			for (var i = 0; i < _authenticationOptions.length; i++) {
				if (_authenticationOptions[i].activation() !== ActivationType.EID_CLIENT
						|| !_authenticationOptions[i].matchesType(data.card.type())) {
					continue;
				}

				_controlView.disableAuthenticationOption(_authenticationOptions[i]);

				_controlView.enableAuthenticationOptionToolTip(_authenticationOptions[i], 
						_authenticationOptions[i].description() + ' ' + Strings.not_available);
			}
		}


		// public methods

		this.title = function () {
			return _uiStateManager.core().optionsManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _controlView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, data) {
			_authenticationOptions = filterAuthenticationOptions(_uiStateManager.core().optionsManager().authenticationOptions());
			_authenticationOptionEidClient = new Object();

			_providerInfoView.update(_uiStateManager.core().optionsManager().providerInfo());
			_controlView.update(_authenticationOptions, Strings.no_identity_available);

			initAuthenticationOptionViews();

			EventListenerRegistry.addListener('CARD_RECOGNIZED', cardRecognized);
			EventListenerRegistry.addListener('CARD_REMOVED', cardRemoved);
			EventListenerRegistry.addListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', eidClientDetectionCycleFinished);

			EventListenerRegistry.addOneTimeListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', function () {
				Util.callCallbacks(doneCallback);
			});

			_uiStateManager.core().eidClientManager().startDetection(_authenticationOptions);
			
			//data get's set in attribute_selection state
			if (_authenticationOptions.length === 1 && !data) {
				//check if cloudID is available/usable
				var identities = [{}];
				if (_authenticationOptions[0].cloudID()) {
					identities = _uiStateManager.core().cloudIdentitiesManager()
							.getIdentitiesByAuthenticationOption(_authenticationOptions[0]);
				}
				if (identities.length > 0) {
					setTimeout(function(){
						authenticationOptionClickHandler(_authenticationOptions[0]);
					},20);
				}
			}
		};

		this.leave = function (doneCallback) {
			_uiStateManager.core().eidClientManager().stopDetection(_authenticationOptions);

			EventListenerRegistry.removeListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', eidClientDetectionCycleFinished);
			EventListenerRegistry.removeListener('CARD_RECOGNIZED', cardRecognized);
			EventListenerRegistry.removeListener('CARD_REMOVED', cardRemoved);

			_authenticationOptions = null;
			_authenticationOptionEidClient = null;

			Util.callCallbacks(doneCallback);
		};
	}

	AuthenticationOptionSelectionState.prototype = Object.create(UIState.prototype);

	return AuthenticationOptionSelectionState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/AuthenticationOptionSelectionState.js
// module id = 322
// module chunks = 2